import { render, staticRenderFns } from "./users.vue?vue&type=template&id=55c04186&scoped=true"
import script from "./users.vue?vue&type=script&lang=ts"
export * from "./users.vue?vue&type=script&lang=ts"
import style0 from "./users.vue?vue&type=style&index=0&id=55c04186&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c04186",
  null
  
)

export default component.exports